import { render, staticRenderFns } from "./electric-charge-add-service.vue?vue&type=template&id=0c3248a7&scoped=true&"
import script from "./electric-charge-add-service.vue?vue&type=script&lang=js&"
export * from "./electric-charge-add-service.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-add-service.vue?vue&type=style&index=0&id=0c3248a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3248a7",
  null
  
)

export default component.exports